/**
 * This custom hook provides the functionality to save a user with the given parameters.
 */

import {useContext, useState} from "react";
import {FirebaseAuthContext} from "../../../../commons/firebase/FirebaseAuthProvider";
import {useHistory} from "react-router-dom";
import {useSnackbar} from "notistack";
import {firebaseService} from "../../../../commons/firebase/Firebase";
import {useIntl} from "react-intl";

const useCreateUser = () => {
    const [saveInProgress, setSaveInProgress] = useState(false)

    const {signedInUser} = useContext(FirebaseAuthContext);
    const history = useHistory();

    const {enqueueSnackbar} = useSnackbar();

    // Internationalization for simple strings
    const intl = useIntl();

    const create = async (user) => {
        setSaveInProgress(true)

        const idToken = await signedInUser.getIdToken()
        return fetch('/reg-main/users', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                idToken: idToken,
                userData: user
            })
        })
            .then(async (data) => {
                // Throw an error including the textual status of the HTTP response code (no detailed message necessary)
                if (data.status !== 200) {
                    throw new Error((await data.json()).status)
                }

                // As the backend triggered a user-init mail, inform the current user about it
                enqueueSnackbar(
                    intl.formatMessage({
                        id: 'app.users.messages.new.success',
                        defaultMessage: 'User {firstName} {secondName} created. Password init link sent to {email}.'
                    }, {firstName: user.firstName, secondName: user.secondName, email: user.email}), {
                        variant: 'success',
                        preventDuplicate: true,
                        autoHideDuration: 3000
                    });

                history.push("/admin/users");
            })
            .catch((error) => {
                enqueueSnackbar(
                    intl.formatMessage({
                        id: 'app.users.messages.new.error',
                        defaultMessage: 'Something went wrong while creating the user: {error}'
                    }, {error: error.message}), {
                        variant: 'error',
                        preventDuplicate: true,
                        autoHideDuration: 5000
                    });
            }).finally(() => {
                setSaveInProgress(false)
            })
    }

    const cancel = () => {
        history.push("/admin/users");
    }

    return {create, saveInProgress, cancel}
}
export default useCreateUser;